/**
 * FathomVoyage — Shared Formatters
 */

export const fmt     = (n) => n == null ? '—' : `$${Number(n).toLocaleString()}`;
export const fmtN    = (n) => n == null ? '—' : Number(n).toLocaleString();
export const sign    = (n) => n > 0 ? '+' : '';
export const signFmt = (n) => n == null ? '—' : `${n > 0 ? '+' : ''}$${Math.abs(n).toLocaleString()}`;

export const changeClass = (n) =>
  n == null ? 'flat' : n > 0 ? 'up' : n < 0 ? 'down' : 'flat';

export const changeArrow = (n) =>
  n > 0 ? '▲' : n < 0 ? '▼' : '—';

export const fmtDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

export const fmtTime = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleTimeString('en-GB', {
    hour: '2-digit', minute: '2-digit'
  });
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${fmtDate(iso)} ${fmtTime(iso)}`;
};

export const hoursAgo = (iso) => {
  if (!iso) return null;
  return Math.round((Date.now() - new Date(iso)) / (1000 * 60 * 60));
};

export const pctFmt = (n, decimals = 2) =>
  n == null ? '—' : `${Number(n).toFixed(decimals)}%`;

export const fmtMillions = (n) => {
  if (n == null) return '—';
  if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000)     return `$${(n / 1_000).toFixed(0)}K`;
  return `$${n}`;
};
